// ============================================================
// DM-LMS — Better Auth React Client
// baseURL points at the Workers API origin — must be absolute since
// the web app (Pages) and API (Workers) are deployed on different
// origins in staging/production.
// ============================================================

import { createAuthClient } from "better-auth/react";

// Explicit return-type annotation avoids TS2742: without it, `declaration: true`
// (tsconfig.base.json) forces tsc to serialize better-auth's inferred client
// type, which pulls in unnameable internal (.pnpm) module paths.
export const authClient: ReturnType<typeof createAuthClient> = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL ?? "",
});
